type SupabasePasswordResetClient = {
  auth: {
    resetPasswordForEmail: (
      email: string,
      options: { redirectTo: string },
    ) => Promise<{ error: { message?: string } | null }>
  }
}

export type PasswordResetResult =
  | { ok: true }
  | { ok: false; error: string }

function getPasswordResetRedirect(currentUrl: string): string {
  const configuredAppUrl = process.env.NEXT_PUBLIC_APP_URL?.trim()
  const baseUrl = configuredAppUrl || new URL(currentUrl).origin
  const redirectUrl = new URL('/auth/callback', baseUrl)
  redirectUrl.searchParams.set('next', '/account/reset-password')
  return redirectUrl.toString()
}

export async function sendPasswordResetEmail(
  supabase: SupabasePasswordResetClient,
  email: string,
  currentUrl: string,
): Promise<PasswordResetResult> {
  const trimmedEmail = email.trim()
  if (!trimmedEmail) {
    return { ok: false, error: 'Enter your email first.' }
  }

  const redirectTo = getPasswordResetRedirect(currentUrl)
  const { error } = await supabase.auth.resetPasswordForEmail(trimmedEmail, {
    redirectTo,
  })

  if (error) {
    return { ok: false, error: error.message || 'Could not send reset email.' }
  }

  return { ok: true }
}
